import PropTypes from 'prop-types';
import React from 'react';
import { Alignment, Fit, Layout, useRive } from 'rive-react';

const WebPaywalls = ({ title, description }) => {
  const { RiveComponent, riveWrapperRef } = useRive({
    src: '/animations/web-paywalls.riv',
    stateMachines: 'SM',
    autoplay: true,
    layout: new Layout({
      fit: Fit.Contain,
      alignment: Alignment.Center,
    }),
  });

  return (
    <section className="web-paywalls safe-paddings">
      <div className="container flex justify-between items-center gap-36 xl:gap-3 lg:gap-[18px] md:flex-col-reverse md:gap-0">
        <div
          className="w-1/2 aspect-[528/500] md:w-3/4 sm:w-full sm:self-start"
          ref={riveWrapperRef}
        >
          <RiveComponent className="relative pointer-events-none size-full" />
        </div>
        <div className="max-w-[544px] w-1/2 md:w-full md:max-w-80 md:text-center">
          <h2 className="fs-52 text-new-black xl:pr-20 xl:text-[44px] lg:pr-16 lg:text-[32px] md:pr-0 md:text-[24px]">
            {title}
          </h2>
          <p className="fs-20 mt-4 pr-22 text-pretty text-new-gray-1 xl:pr-0 lg:pr-4 md:px-1">
            {description}
          </p>
        </div>
      </div>
    </section>
  );
};

WebPaywalls.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default WebPaywalls;
